import { OrderOperationType } from 'api/types/entity/account/order';
import { isFinanceProject } from 'config';
import { Stack } from 'libs/ui';
import {
  ExecutionTermsSection,
  FinancialInstrumentSection,
  SenderOrRecipientDetailsSection,
  ConfirmationDocumentSection,
  TransactionVolumeSection,
  TransferVolumeSection,
  AdditionalParametersSection,
  ExecutionPeriodSection,
} from 'modules/account/orderModule/common/components/sections';

import { useOrderContext } from '../../providers/OrderProvider';
import { MainInformationSection, OperationsSection } from '../sections';

export const OrderFormContent = () => {
  const { orderType, order } = useOrderContext();

  const isPurchaseOrSale =
    orderType === OrderOperationType.SecuritiesPurchase ||
    orderType === OrderOperationType.SecuritiesSale;

  const isWithdrawalOrDeposit =
    orderType === OrderOperationType.SecuritiesWithdrawal ||
    orderType === OrderOperationType.SecuritiesDeposit;

  const isFinance = isFinanceProject();

  return (
    <Stack flex={1} spacing={32}>
      <MainInformationSection />
      <ExecutionPeriodSection
        closedDate={{ show: true, value: order?.closedDate }}
        signedAt={{ show: true, value: order?.signedAt }}
      />
      <ExecutionTermsSection
        isShowOperationKind={isWithdrawalOrDeposit}
        isShowOperationPurpose={isPurchaseOrSale && isFinance}
        isShowOrderType={isPurchaseOrSale}
        isShowYield={isPurchaseOrSale}
        marketType={{
          show: isPurchaseOrSale,
          value: order?.executionTerms.marketType,
        }}
        transactionVenue={{
          show: isPurchaseOrSale,
          value: order?.executionTerms.transactionVenue,
        }}
      />
      <FinancialInstrumentSection />
      {isPurchaseOrSale && <TransactionVolumeSection />}
      {isWithdrawalOrDeposit && <TransferVolumeSection />}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="sender" />
      )}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="recipient" />
      )}
      {isWithdrawalOrDeposit && <AdditionalParametersSection />}
      {isWithdrawalOrDeposit && <ConfirmationDocumentSection />}
      <OperationsSection />
    </Stack>
  );
};
